 
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ExtrasService } from '../extras/extras.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private translate: TranslateService,
    private extrasService: ExtrasService
  ) { }
  // En AlertService
  isLoading = false;

  public async successOkAccion(
    messageKey: string = 'swal_messages.complete_success',
    titleKey: string = 'swal_messages.success',
    onOk?: () => void // Función opcional para ejecutar al presionar OK
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    const result = await Swal.fire({
      title: title,
      text: message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
    });
    // Ejecutar la función si el botón OK fue presionado
    if (result.isConfirmed && onOk) {
      onOk();
    }

    return result;
  }

  public async successOk(
    messageKey: string = 'swal_messages.complete_success',
    titleKey: string = 'swal_messages.success'
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    return Swal.fire({
      title: title,
      text: message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
    });
  }

  public async success(
    messageKey: string = 'swal_messages.complete_success',
    titleKey: string = 'swal_messages.success'
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    return Swal.fire({
      title: title,
      text: message,
      icon: 'success',
      timer: 2000, // 2 segundos
      showConfirmButton: false, // Ocultar el botón de confirmación
      allowOutsideClick: false,
    });
  }

  public async argumentario(explanatoryText: string): Promise<any> {
    const message = explanatoryText;
    const title = await this.translate.get('swal_messages.argumentario').toPromise();
    return Swal.fire({
      title: title,
      html: message,
      icon: 'info',  // Puedes cambiar el icono según el contexto, por ejemplo 'warning', 'success', etc.
      confirmButtonText: 'Aceptar'
    });
  }

  public async error(
    messageKey: any = 'swal_messages.error_occurred',
    extraErrorData: any = '',
    titleKey: string = 'swal_messages.error'
  ): Promise<any> {
    try {
      let missingPropertiesKeys: any = [];
      let errorKeys: any = [];
      let url: any = '';

      url = this.findUrlParam(messageKey);

      if (messageKey && typeof messageKey === 'object' && messageKey.hasOwnProperty('missing_properties')) {
        const missingProperties = messageKey.missing_properties;
        const { missing_properties, ...resto } = messageKey;
        missingPropertiesKeys = missingProperties;
        errorKeys = resto;
      } else {
        errorKeys = messageKey;
      }
      let message: string = '';
      let extraMessage: any = '';

      if (typeof errorKeys === 'string') {
        message = await this.translate.get(errorKeys).toPromise();
      }

      if (typeof errorKeys === 'object') {
        message = await this.extrasService.traducirError(errorKeys);
      }
      if (missingPropertiesKeys.length > 0) {
        extraMessage = await this.extrasService.traducirError2(
          missingPropertiesKeys
        );
      }

      if (extraErrorData != '') {
        const translated = await Promise.all(
          extraErrorData.map(async (item: string) => {
            const translatedItem = await this.translate.get(item).toPromise();
            return translatedItem;
          })
        );
        extraMessage = translated.join(', ');
      }

      const title = await this.translate.get(titleKey).toPromise();
      let mensaje = (message + (extraMessage ? ' ' + extraMessage : '')).trim();
      mensaje = mensaje.split('\n').map(line => `<span> ${line}</span>`).join('<br>');
      if (url) {
        const check_url = await this.translate.get("swal_messages.check_url").toPromise();
        mensaje += `<br><br><a href="${url}" target="_blank">${check_url}</a>`;
      }
      return Swal.fire({
        title: title,
        html: mensaje,
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar',
      });
    } catch (error) {
      console.error('[AlertService.error] failed to translate error:', error, 'original messageKey:', messageKey);
      const title = await this.translate.get("swal_messages.error").toPromise();
      const mensaje = await this.translate.get("swal_messages.error_occurred").toPromise();
      return Swal.fire({
        title: title,
        html: mensaje,
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
      });
    }

  }

  public async error_bkp(
    messageKey: any = 'swal_messages.error_occurred',
    extraErrorData: any = '',
    titleKey: string = 'swal_messages.error'
  ): Promise<any> {
    try {
      let missingPropertiesKeys: any = [];
      var errorKeys: any = [];
      let url: any = '';

      url = this.findUrlParam(messageKey);

      if (messageKey.hasOwnProperty('missing_properties')) {
        const missingProperties = messageKey.missing_properties;
        const { missing_properties, ...resto } = messageKey;
        const otherErrors = resto;
        missingPropertiesKeys = missingProperties;
        errorKeys = otherErrors;
      } else {
        errorKeys = messageKey;
      }
      let message: string | undefined;
      let extraMessage: any = '';

      if (typeof errorKeys === 'string') {
        message = await this.translate.get(errorKeys).toPromise();
      }

      if (typeof errorKeys === 'object') {
        message = await this.extrasService.traducirError(errorKeys);
      }
      if (missingPropertiesKeys.length > 0) {
        extraMessage = await this.extrasService.traducirError2(
          missingPropertiesKeys
        );
      }

      if (extraErrorData != '') {
        extraMessage = await Promise.all(
          extraErrorData.map(async (item: string) => {
            const translatedItem = await this.translate.get(item).toPromise();
            return translatedItem;
          })
        );
        extraMessage.join(', ');
      }

      const title = await this.translate.get(titleKey).toPromise();
      let mensaje = message + ' ' + extraMessage;
      mensaje = mensaje.split('\n').map(line => `<span> ${line}</span>`).join('<br>');
      if (url) {
        const check_url = await this.translate.get("swal_messages.check_url").toPromise();
        mensaje += `<br><br><a href="${url}" target="_blank">${check_url}</a>`;
      }
      return Swal.fire({
        title: title,
        html: mensaje,
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar',
      });
    } catch (error) {
      const title = await this.translate.get("swal_messages.error").toPromise();
      const mensaje = await this.translate.get("swal_messages.error_occurred").toPromise();
      return Swal.fire({
        title: title,
        html: mensaje,
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
      });
    }
  }

  public async error2(
    messageKey: any = 'swal_messages.error_occurred',
    extraErrorData: any = '',
    titleKey: string = 'swal_messages.error'
  ): Promise<any> {
    let message: string | undefined;
    let extraMessage: any = '';
    let missingPropertiesKeys: any = [];
    var errorKeys: any = [];
    if (messageKey.hasOwnProperty('missing_properties')) {
      // missingPropertiesKeys = messageKey.missing_properties;
      const missingProperties = messageKey.missing_properties;

      // Extraer el resto del objeto sin missing_properties
      const { missing_properties, ...resto } = messageKey;

      // Asignar las variables
      const otherErrors = resto;
      missingPropertiesKeys = missingProperties;
      errorKeys = otherErrors;
    }
    if (typeof errorKeys === 'object') {
      message = await this.extrasService.traducirError2(errorKeys);
    }
    if (missingPropertiesKeys.length > 0) {
      extraMessage = await this.extrasService.traducirError2(
        missingPropertiesKeys
      );
    }

    const title = await this.translate.get(titleKey).toPromise();
    return Swal.fire({
      title: title,
      text: message + ' ' + extraMessage,
      icon: 'error',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Cerrar',
    });
  }

  public async warning(
    messageKey: string = 'swal_messages.warning_confirm',
    titleKey: string = 'swal_messages.warning'
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      confirmButtonColor: '#ffc107',
      confirmButtonText: 'Entendido',
      allowOutsideClick: false,
    });
  }

  public async confirmation(
    messageKey: string = 'swal_messages.are_you_sure_confirm',
    titleKey: string = 'swal_messages.confirm',
    confirmButtonTextkey: string = 'swal_messages.confirm',
    cancelButtonTextkey: string = 'swal_messages.cancel'
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    const confirmButtonText = await this.translate
      .get(confirmButtonTextkey)
      .toPromise();
    const cancelButtonText = await this.translate
      .get(cancelButtonTextkey)
      .toPromise();
    return Swal.fire({
      title: title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      allowOutsideClick: false,
      confirmButtonText,
      cancelButtonText,
    });
  }

  public async confirmation2(
    messageKey: string = 'swal_messages.are_you_sure_confirm',
    titleKey: string = 'swal_messages.confirm',
    confirmButtonTextkey: string = 'swal_messages.confirm',
    cancelButtonTextkey: string = 'swal_messages.cancel'
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    const confirmButtonText = await this.translate
      .get(confirmButtonTextkey)
      .toPromise();
    const cancelButtonText = await this.translate
      .get(cancelButtonTextkey)
      .toPromise();
    return Swal.fire({
      title: title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      allowOutsideClick: false,
      confirmButtonText,
      cancelButtonText,
    });
  }

  public async loading(

    messageKey: string = 'swal_messages.please_wait',
    titleKey: string = 'swal_messages.loading'
  ): Promise<void> {
    if (this.isLoading) return;
    this.isLoading = true;
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    Swal.fire({
      title: title,
      text: message,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  public close(): void {
    this.isLoading = false;
    Swal.close();
  }

  public isUrl(param: string): boolean {
    try {
      new URL(param);
      return true;
    } catch (_) {
      return false;
    }
  }

  private findUrlParam(obj: any): string | null {
    if (obj && typeof obj === 'object') {
      for (const key of Object.keys(obj)) {
        if (key === 'param' && this.isUrl(obj[key])) {
          return obj[key];
        }
        const value = obj[key];
        if (typeof value === 'object') {
          const found = this.findUrlParam(value);
          if (found) return found;
        }
      }
    }
    return null;
  }

  /**
   * Muestra un popup con dos botones de selección personalizados.
   * @param messageKey Clave de traducción o texto para el mensaje
   * @param titleKey Clave de traducción o texto para el título
   * @param option1TextKey Clave de traducción o texto para el botón 1
   * @param option2TextKey Clave de traducción o texto para el botón 2
   * @returns Promise con el resultado del botón seleccionado
   */
  public async twoOptions(
    messageKey: string,
    titleKey: string,
    option1TextKey: string,
    option2TextKey: string
  ): Promise<any> {
    const message = await this.translate.get(messageKey).toPromise();
    const title = await this.translate.get(titleKey).toPromise();
    const option1Text = await this.translate.get(option1TextKey).toPromise();
    const option2Text = await this.translate.get(option2TextKey).toPromise();
    return Swal.fire({
      title: title,
      html: message,
      icon: 'question',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: option1Text,
      cancelButtonText: option2Text,
    });
  }
}